import { render, staticRenderFns } from "./aboutProduct.vue?vue&type=template&id=13a6ec21&scoped=true&"
import script from "./aboutProduct.vue?vue&type=script&lang=js&"
export * from "./aboutProduct.vue?vue&type=script&lang=js&"
import style0 from "./aboutProduct.vue?vue&type=style&index=0&id=13a6ec21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6ec21",
  null
  
)

export default component.exports